import { IProductVIPItemData } from 'modules/shop/types/vip';
import { useState } from 'react';
import { cashierCtrl } from '../../cashier.controller';
import { IUISelectItem } from '../../cashier.interface';
import HeaderActionButton, { HeaderActionButtonType } from '../../HeaderActions/HeaderActionButton';
import ModalVip from './ModalVip';
type Props = {
  add: (item: IUISelectItem) => void;
};
const CashierVIP = ({ }: Props) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onClick = () => {
    setOpen(true);
  };

  const onBuy = (o: IProductVIPItemData) => {
    cashierCtrl.saleVIP(o);
    onClose();
  };

  return (
    <>
      <HeaderActionButton type={HeaderActionButtonType.VIP} onClick={onClick} />
      <ModalVip visible={open} onClose={onClose} onBuy={onBuy} />
    </>
  );
};

export default CashierVIP;
